import { useCallback, useEffect, useRef, useState } from "react";

const useElementSize = () => {
  const ref: any = useRef();
  const stepWrapperRef: any = useRef();

  const handleSize = useCallback(() => {
    const calculatedHeight = ref?.current?.offsetHeight + 141; // 141 = header height + spacing
    stepWrapperRef.current.style.minHeight =
      window.innerHeight - calculatedHeight + "px";
  }, [ref?.current?.offsetHeight]);

  useEffect(() => {
    if (ref?.current?.offsetHeight) {
      handleSize();
    }
  }, [ref?.current?.offsetHeight]);

  return {
    ref,
    stepWrapperRef,
  };
};

export default useElementSize;
